<template>
	<contentBox v-bind:noScrollFix="true" v-if="permits && searchType === 'permit'" mainId="permits">
		<contentTitle v-bind:label="permits.length+' PERMITS'" labelClass="text-white">
		</contentTitle>
		<contentBody bg="rgba(55,71,79,0.6)">
			<div class="p-3">
				<div class="card no-hover mb-2 field-row" v-if="permits.length < 1">
					<div class="clearfix p-2">
						<strong>No permits found</strong>
						<p class="mb-0">Try broadening your search or zooming out in the map</p>
					</div>
				</div>
				<div v-else class="card mb-2 field-row" 
					v-bind:class="getHighlightClass(permit)"
					v-on:mouseenter="mouseenter($event,permit)" v-on:mouseleave="mouseleave($event,permit)" 
					v-on:click="click($event,permit)"
					v-for="(permit, index) in permits">

					<div class="pt-2 mx-2 pb-1 font-weight-bold border-bottom-gray font-10 text-uppercase">
						{{permit.typeRaw}} 
						<sup class="text-red" v-if="getStatusIsNew(permit)">New</sup>
						<span class="float-right">
							<a :href="jurisdictionPermitURL(permit)" v-if="permit && permit.link" target="_blank">
								#{{permit.jurisdictionPermitId}}
								<i class="material-icons md-12">open_in_new</i>
							</a>
							<span v-else>#{{permit.jurisdictionPermitId}}</span>
						</span>
					</div>
					<div class="pt-2">
						<div class="clearfix pb-2 px-2" v-if="permit.apn !== null">
							<label class="mb-0 font-weight-light">Parcel APN</label>
							<div class="float-right font-weight-bold">
								<span v-if="!permit.parcelId">
									N/A
								</span>
								<a v-else href="javascript:" v-on:click="parcelGo($event,permit.parcelId)">
									{{formatAPN(permit.apn)}}
								</a>
							</div>
						</div>
						<div class="clearfix pb-2 px-2" v-if="permit.projectName !== null">
							<label class="mb-0 font-weight-light">Project name</label>
							<div class="float-right font-weight-bold">
								{{permit.projectName}}
							</div>
						</div>
						<div class="clearfix pb-2 px-2" v-if="permit.projectId !== null">
							<label class="mb-0 font-weight-light">Project ID</label>
							<div class="float-right font-weight-bold">
								{{permit.projectId}}
							</div>
						</div>
						<div class="clearfix pb-2 px-2" v-if="permit.contractor && permit.contractor.companyName !== null">
							<label class="mb-0 font-weight-light">Contractor</label>
							<div class="float-right font-weight-bold">
								{{permit.contractor.companyName}}
							</div>
						</div>
						<div class="clearfix pb-2 px-2">
							<label class="mb-0 font-weight-light">Status</label>
							<div class="float-right font-weight-bold">
								{{getStatus(permit)}} on {{getStatusDate(permit)}}</td>
							</div>
						</div>
						<div class="clearfix pb-2 px-2" v-if="permit.description !== null">
							<div>
								{{descriptionShort(permit.description)}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</contentBody>
	</contentBox>
</template>

<script>

import contentBox from '../content';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';

const millsecondsIsNew = 1000*60*60*24*90;

export default {
	name: 'permit-list',

	props:{
		search: String,
	},

	components:{
		contentBox,
		contentBody,
		contentTitle
	},

	data: function(){
		return {
			tabActive:'overview',
			permitHighlight:null
		}
	},

	destroyed: function(){
		this.$store.dispatch('MAP_POI_HOVER_SET', null);
	},

	computed: {
		permits: function(){
			return this.$store.state.search.results;
		},
		searchType:function(){
			return this.$store.state.search.type;
		},
		poiHighlight: function(){
			return this.$store.state.map.poiHighlight;
		},
		poiClick: function(){
			return this.$store.state.map.poiClick;
		},
		mapLoaded: function(){
			return this.$store.state.map.loaded;
		}
	},
	methods: {
		jurisdictionPermitURL: function(permit){
			return permit.link;
		},
		parcelURL: function(id){
			if (!id){
				return false;
			}
			return "/parcels/"+id;
		},
		parcelGo:function(e,parcelId){
			const route = {
				name: 'parcels', 
				params:{
					id: parcelId
				}
			};
			this.$router.push(route);
			e.stopPropagation();
			return false;
		},
		formatAPN: function(apn){
			if (!apn || (apn && apn.length == 0)){
				return "N/A"
			}
			if (apn.length != 10) {
				return apn
			}

			//	split the string
			var strs = [];
			strs[0] = apn.substr(0, 3);
			strs[1] = apn.substr(3, 3);
			strs[2] = apn.substr(6, 2);
			strs[3] = apn.substr(8, 2);

			return strs.join("-")
		},
		//	pass in dateString, outputs MM/DD/YYYY format
		formatDate: function(dateStr){
			if (!dateStr){
				return ""
			}
			var d = new Date(dateStr);

			//	sniffing for invalid dates
			if (d.getUTCFullYear() == 1){
				return ""
			}

			//	format our datestring
			return (d.getUTCMonth()+1) +"/"+ d.getUTCDate() + "/" + d.getUTCFullYear();
		},

		validDate:function(dateStr){
			try{
				var d = new Date(dateStr);
				if (d.getUTCFullYear() == 1){
					return false;
				}
				return true;
			} catch(e){
				return false;
			}
		},

		//	check if a date is new
		isNew: function(dateStr){
			if (!dateStr){
				return ""
			}
			let d = new Date(dateStr);
			let today = new Date();

			//	get date diff to determine "new"
			if ((today - d) < millsecondsIsNew){
				return true;
			}
			return false;
		},
		mouseenter: function(e, permit){
			let title;
			if (permit.parcelId){
				title = '<a href="/parcels/'+permit.parcelId+'" target="_blank">'+permit.typeRaw+'</a>';
			} else {
				title = permit.typeRaw;
			}

			const feature = {
				id:permit.id,
				source:'poi'
			};

			this.$store.dispatch('MAP_FEATURE_HOVER_SET', [feature]);
		},
		click: function(e, permit){
			const route = {
				name: 'permit', 
				params:{
					id: permit.id
				}
			};
			this.$router.push(route);
		},
		mouseleave: function(e, permit){
			this.$store.dispatch('MAP_FEATURE_HOVER_SET', null);
		},
		getStatus:function(permit){
			if (this.validDate(permit.completedDate)){
				return 'Completed';
			}
			if (this.validDate(permit.issuedDate)){
				return 'Issued';
			}
			if (this.validDate(permit.appliedDate)){
				return 'Applied';
			}
		},
		getStatusLast:function(permit){
			if (this.validDate(permit.completedDate)){
				return permit.completedDate;
			}
			if (this.validDate(permit.issuedDate)){
				return permit.issuedDate;
			}
			if (this.validDate(permit.appliedDate)){
				return permit.appliedDate;
			}
		},
		getStatusDate:function(permit){
			return this.formatDate(this.getStatusLast(permit));
		},
		getStatusIsNew:function(permit){
			return this.isNew(this.getStatusLast(permit));
		},
		getHighlightClass:function(permit){
			return (permit.id === this.permitHighlight)? 'highlight': '';
		},
		checkReady:function(){ //called to check if and resolve when all resources have been loaded
			if (!this.permits || !this.mapLoaded) return;
			this.ready();
		},
		ready:function(){
		},
		updateTitleTag:function(){
			if (!this.permits) return document.title = 'Permits - Scoutred Maps';

			document.title = this.permits.length +' permits - Scoutred Maps';
		},
		descriptionShort:function(description){
			if (description && description.length > 150){
				return description.substr(0,150)+'...';
			}
		}
	},

	watch:{
		permits:function(){
			this.checkReady();
			this.updateTitleTag();
		},
		poiHighlight:function(newPoi){
			if (!newPoi){
				this.$data.permitHighlight = null;
				return;
			}
			this.$data.permitHighlight = newPoi.properties.permitId;
		},
		poiClick:function(newPoi){
		},
		mapLoaded:function(){
			this.checkReady();
		}
	}
}

</script>

<style>

#permits .font-10{font-size:10px;}

#permits h5{
	font-size:14px;
	line-height:18px;
}
#permits .field-row{
	font-size:14px;
	line-height:24px;
}
#permits .card{background-color:rgba(255,255,255,0.9);}
#permits .card:not(.no-hover){cursor:pointer;}
#permits .highlight,#permits .card:hover:not(.no-hover){background-color:rgba(255,255,255,1);}

.table-text-sm{
	font-size:0.85em;
}

</style>


// WEBPACK FOOTER //
// src/components/permit/permit-list.vue